<script setup lang="ts">
import { useAuthStore } from "~/stores/auth";

const authStore = useAuthStore();

onMounted(() => {
  const routeToken = useRoute().query.token;
  const routeRefreshToken = useRoute().query.token_refresh;
  const token = Array.isArray(routeToken) ? routeToken[0] : routeToken;
  const refreshToken = Array.isArray(routeRefreshToken)
    ? routeRefreshToken[0]
    : routeRefreshToken;

  if (token && refreshToken) authStore.setToken(token, refreshToken);

  console.log(
    `%cBBI v1.2.5`,
    `color: #34584e; font-size: 14px; font-weight: bold; background-color: #cb9040; padding: 4px 8px; border-radius: 4px;`
  );
});
</script>

<template>
  <NuxtLayout>
    <ClientOnly>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TWJVCPDB"
          height="0"
          width="0"
          style="display: none; visibility: hidden"
        ></iframe>
      </noscript>
    </ClientOnly>
    <NuxtPage />
  </NuxtLayout>
</template>
